import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

import "swiper/css";

const TopBrands = ({ brands = [] }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const handleClick = (brand) => {
    navigate(`/product-category?brand=${brand.name}`);
  };

  if (!brands?.length) return null;

  return (
    <div className="max-w-8xl mx-auto mt-2">

      {/* 🔥 PREMIUM BACKGROUND */}
      <div className="relative rounded-md p-4 md:p-6 bg-gradient-to-br from-blue-50 via-white to-indigo-50 overflow-hidden">

        {/* Glow Background */}
        <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-200 opacity-30 blur-3xl rounded-full"></div>
        <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-indigo-200 opacity-30 blur-3xl rounded-sm"></div>

        {/* HEADER */}
        <div className="flex justify-between items-center  mb-6 relative z-10">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-800">
            Top Brands
          </h2>
        </div>

        {/* 📱 MOBILE */}
        {isMobile ? (
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2000 }}
            loop
            spaceBetween={14}
            slidesPerView={2.2}
          >
            {brands.map((brand, i) => (
              <SwiperSlide key={i}>
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => handleClick(brand)}
                  className="relative bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl p-5 flex flex-col items-center justify-center shadow-lg cursor-pointer"
                >
                  {/* Glow */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-400/10 to-purple-400/10 opacity-0 group-hover:opacity-100 blur-xl"></div>

                  <img
                    src={brand.img}
                    alt={brand.name}
                    className="h-14 object-contain z-10"
                  />

                  <p className="mt-3 text-xs font-semibold text-gray-700 z-10">
                    {brand.name}
                  </p>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (

          /* 💻 DESKTOP PREMIUM GRID */
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 relative z-10">

            {brands.map((brand, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                whileHover={{
                  y: -12,
                  scale: 1.05
                }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleClick(brand)}
                className="group relative cursor-pointer"
              >

                {/* 🔥 CARD */}
                <div className="relative bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl p-6 flex flex-col items-center justify-center shadow-md hover:shadow-2xl transition-all">

                  {/* 🔥 GRADIENT BORDER */}
                  <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-blue-400/40"></div>

                  {/* 🔥 GLOW */}
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition bg-gradient-to-r from-blue-400/10 to-purple-400/10 blur-xl"></div>

                  {/* LOGO */}
                  <img
                    src={brand.img}
                    alt={brand.name}
                    className="h-16 object-contain transition duration-300 group-hover:scale-110 z-10"
                  />

                  {/* NAME */}
                  <p className="mt-4 text-sm font-semibold text-gray-800 z-10">
                    {brand.name}
                  </p>

                </div>

              </motion.div>
            ))}

          </div>
        )}

      </div>

    </div>
  );
};

export default TopBrands;